import React from "react";
import PhoneInput from "react-phone-input-2";
import {
  CircularProgress,
  Divider,
  FormControl,
  FormHelperText,
  Typography,
} from "@material-ui/core";
import * as Yup from "yup";
import pt from "react-phone-input-2/lang/pt.json";
import { Formik } from "formik";
import { useMain, useMainState } from "modules/app/contexts";
import { ButtonAlert } from "../NewCustomer/styles";
import { Container, Legend } from "./styles";
import { useTranslation } from "react-i18next";
import { UserForm } from "modules/app/components/UserForm";

function MyProfile() {
  const { user } = useMainState();
  const { t } = useTranslation();

  if (!user) {
    return <></>;
  }

  const userForm = {
    name: user.name,
    email: user.email,
    phone1: user.phone1,
    signature: user.signature,
    password: null,
    passwordConfirmation: null,
  };

  return (
    <Container>
      <Typography style={{ fontWeight: "bold", fontSize: 22 }}>
        Atualizar meu usuário
      </Typography>

      <UserForm userForm={userForm} id={user.id} myProfile />
    </Container>
  );
}

export default MyProfile;
